'use strict';

var GridToolbarRuleListingDirective = function GridToolbarRuleListingDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmGridPanel',
    template: require('../templates/grid-toolbar-system-configuration.html'),
    controller: 'GridToolbarSystemConfigurationController',
    link: function link() {}
  };
};
GridToolbarRuleListingDirective.$inject = [];
module.exports = GridToolbarRuleListingDirective;